const logger = require("@gc-npm/node.utils.logger").default;
const LOGGER_COLORS =
    require("@gc-npm/node.utils.logger").LOGGER_COLORS;
import { getAllItem as getAllItemPromise } from "@gc-npm/adabyron.catalogue.get-all-item";
export const getAllItem = async ({
    context,
    Urlfilters,
    offerCategory,
    offerCategory2,
    build,
    idFront,
    onSuccess,
    ssrHeaders
}) => {
    const startTime = Date.now();

    const response = await getAllItemPromise({
        context,
        Urlfilters,
        offerCategory,
        offerCategory2,
        build,
        idFront,
        onSuccess,
        ssrHeaders
    })
    const endTime = Date.now();
    const duration = endTime - startTime;
    logger(
        [`Get all items (search) completado en ${duration}ms`],
        [LOGGER_COLORS.ORANGE]
    );
    return response;
}